"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var PaymentTotal_1 = __importDefault(require("./PaymentTotal"));
var Calculator_1 = __importDefault(require("../Calculator"));
var to_fixed_1 = __importDefault(require("../utils/to-fixed"));
var Loan = /** @class */ (function () {
    function Loan(amount, downPayment, interest, years, paymentsPerYear) {
        this.amount = amount;
        this.downPayment = downPayment;
        this.downPaymentRatio = this.calculateDownPaymentRatio(amount, downPayment);
        this.interest = interest;
        this.years = years;
        this.paymentsPerYear = paymentsPerYear;
        this.total = new PaymentTotal_1.default(0, 0, 0);
        this.payments = [];
        this.monthlyPayment = 0;
    }
    Loan.prototype.calculateDownPaymentRatio = function (amount, downPayment) {
        if (amount === 0 || downPayment === 0) {
            return 0;
        }
        return to_fixed_1.default(downPayment / amount, 4);
    };
    Loan.prototype.calculate = function () {
        Calculator_1.default.calculate(this);
    };
    return Loan;
}());
exports.default = Loan;
